export default __webpack_public_path__ + "static/d39592797ee0ad7f636db603052c0537.jpeg";